import {useMutation} from "@tanstack/react-query";
import {acceptCustomerOfferMutationOptions} from "./accept-customer-offer.mutation-options";

export function useAcceptCustomerOffer() {
  return useMutation(acceptCustomerOfferMutationOptions());
}
